define(function(require, exports, module) {
    'use strict';

    var user = require('user');
    var Class = require('Class');
    var config = require('config');
    var urlUtil = require('util/url.util');
    var helpers = require('common/addressLookup/sourceProvider/helpers');

    module.exports = Class.create({
        enabled: false,

        abortController: null,

        initialize: function() {
            const enabled = config.get('isPostcodeEnabled');
            const providerName = config.get('postcodeProvider');
            const postcodeConfig = config.get('postcodeConfiguration') || {};
            const countries = config.get('allowedCountries').map(country => country.code.toLowerCase());
            const language = (user.get('lang') || config.get('.defaultLocale')).slice(0, 2);

            // todo postcodeProvider 'UK' is deprecated and will be changed to 'GENERAL'
            this.enabled = enabled && (providerName === 'GENERAL' || providerName === 'UK');

            this.config = {
                key: postcodeConfig.key,
                findUrl: postcodeConfig.url,
                // todo postcodeConfiguration property 'userName' will be renamed later
                retrieveUrl: postcodeConfig.userName,
                countries: countries,
                language: language
            };
        },

        search: function(searchText, id, countryCode) {
            this.cancelFetch();

            return this.fetch(this.config.findUrl, this.prepareFindRequest(searchText, id, countryCode))
                .then(response => helpers.parseFind(response))
                .catch(error => {
                    throw helpers.createFetchError(error);
                });
        },

        retrieve: async function(id) {
            this.cancelFetch();

            return this.fetch(this.config.retrieveUrl, this.prepareRetrieveRequest(id))
                .then(response => helpers.parseRetrieve(response))
                .catch(error => {
                    throw helpers.createFetchError(error);
                });
        },

        cancelFetch: function() {
            if (this.abortController) {
                this.abortController.abort();
            }
        },

        fetch: function(url, params) {
            this.abortController = new AbortController();

            var search = urlUtil.serialize(params);
            var signal = this.abortController.signal;

            return helpers.secureFetch(`${url}?${search}`, {
                method: 'GET',
                signal: signal
            });
        },

        /**
         * IsMiddleware=true is used to disable IP-address bias.
         * If country is specified then search should be performed without IP-address biasing.
         * If no country is specified then search should be limited within countries list with IP-address biasing.
         * @param searchText {string}
         * @param id {string}
         * @param countryCode {string}
         * @returns {Object}
         */
        prepareFindRequest: function(searchText, id, countryCode) {
            const country = countryCode?.toLowerCase() || '';
            const locationParams = countryCode
                ? { Origin: country, Countries: country, IsMiddleware: true }
                : { Countries: this.config.countries.join(',') };

            return {
                Text: searchText,
                Key: this.config.key,
                Language: this.config.language,
                ...id ? { Container: id } : {},
                ...locationParams
            };
        },

        prepareRetrieveRequest: function(id) {
            return {
                Key: this.config.key,
                Id: id
            };
        }
    });
});
